<template>
  <el-container>
    <el-header class="table-header">
      <el-button size="small" type="primary" @click="submit(form)">{{$t('common.Save')}}</el-button>
    </el-header>
    <el-main class="table-main">
      <el-form :model="form" size="mini" label-width="90px" :rules="CommitForm" ref="form" class="table-form">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$t('base.info.url.CenterCode')" prop="centerCode">
              <el-input v-model.trim="form.centerCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.url.CenterName')" prop="centerName">
              <el-input v-model.trim="form.centerName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.url.ServiceCode')" prop="serviceCode">
              <el-input v-model.trim="form.serviceCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.url.ServiceName')" prop="serviceName">
              <el-input v-model.trim="form.serviceName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.url.ModuleCode')" prop="modelCode">
              <el-input v-model.trim="form.modelCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.url.ModuleName')" prop="modelName">
              <el-input v-model.trim="form.modelName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.url.ClassName')" prop="className">
              <el-input v-model.trim="form.className"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.url.ClassMethod')" prop="classMethod">
              <el-input v-model.trim="form.classMethod"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.url.AccessUrl')" prop="accessUrl">
              <el-input v-model.trim="form.accessUrl"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.url.AccessMethod')" prop="accessMethod">
              <el-input v-model.trim="form.accessMethod"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.url.AccessAddress')" prop="accessAddress">
              <el-input v-model.trim="form.accessAddress"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.url.MenuId')" prop="menuId">
              <el-input v-model.trim="form.menuId"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.url.MenuName')" prop="menuName">
              <el-input v-model.trim="form.menuName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.url.FunctId')" prop="functId">
              <el-input v-model.trim="form.functId"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.url.FunctName')" prop="functName">
              <el-input v-model.trim="form.functName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.url.MatchPath')" prop="matchPath">
              <el-input v-model.trim="form.matchPath"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>

export default {
  data () {
    return {
      form: {},
      CommitForm: {
        // name: [{required: true, trigger: 'blur', message: '菜单名称不能为空'}],
        // code: [{required: true, trigger: 'blur', message: '菜单编码不能为空'}],
        // systemId: [{required: true, trigger: 'change', message: '请选择系统'}],
        // remark: [{max: 90, message: '最多90个汉字'}]
      }
    }
  },
  methods: {
    submit (form) {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$api.urlList.urlUpdate({data: this.form}).then((response) => {
            if (response.data.status === 'Y') {
              this.$message({
                message: response.data.message,
                type: 'success'
              })
              this.cancel()
            } else {
              this.$message({
                message: response.data.message,
                type: 'error'
              })
            }
          }).catch((error) => {
            console.log(error)
          })
        }
      })
    },
    cancel () {
      this.$router.push({path: '/urlList'})
      let tabItem = this.$store.getters.rightNav
      this.$store.dispatch('removeTab', {tabItem, fullPath: this.$route.fullPath, router: this.$router})
    }
  },
  created () {
    this.form = this.$route.params.row
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/syssetting/UrlEdit.vue